export const GroupSchedules = {
  en: {
    'Recurring classes': 'Recurring classes',
    Service: 'Service',
    Trainer: 'Trainer',
    Location: 'Location',
    'Available online': 'Available online',
    Note: 'Note',
    Weekdays: 'Weekdays',
    'Start time': 'Start time',
    Spots: 'Spots',
    Period: 'Period',
    'Repeat every N weeks': 'Repeat every N weeks',
    'Generated until': 'Generated until',
    generation_horizon_hint:
      'Classes are generated only up to the company booking horizon ({{days}} days ahead). The rest appear automatically as the horizon moves each day.',
    'Delete this schedule?': 'Delete this schedule?',
    delete_schedule_hint:
      'Future classes nobody signed up for are deleted along with it. The ones people have already booked stay on the calendar, as does everything it has already held.',
    'Cancel the classes people have booked':
      'Cancel the classes people have booked',
    'Change the number of spots': 'Change the number of spots',
    edit_schedule_capacity_hint:
      'Applies to this schedule’s classes that have not started yet, including ones changed separately. Past classes stay as they were.',
    'weekday short: sunday': 'Sun',
    'weekday short: monday': 'Mon',
    'weekday short: tuesday': 'Tue',
    'weekday short: wednesday': 'Wed',
    'weekday short: thursday': 'Thu',
    'weekday short: friday': 'Fri',
    'weekday short: saturday': 'Sat',
  },
  uk: {
    'Recurring classes': 'Регулярні заняття',
    Service: 'Послуга',
    Trainer: 'Тренер',
    Location: 'Локація',
    'Available online': 'Доступно онлайн',
    Note: 'Нотатка',
    Weekdays: 'Дні тижня',
    'Start time': 'Час початку',
    Spots: 'Місць',
    Period: 'Період',
    'Repeat every N weeks': 'Повторювати кожні N тижнів',
    'Generated until': 'Згенеровано до',
    generation_horizon_hint:
      'Заняття генеруються лише до горизонту бронювання компанії ({{days}} дн. наперед). Решта з’являється автоматично, коли горизонт зсувається щодня.',
    'Delete this schedule?': 'Видалити цей розклад?',
    delete_schedule_hint:
      'Майбутні заняття, на які ніхто не записався, буде видалено разом із ним. Ті, на які вже записалися, залишаться в календарі — як і всі, що вже відбулися.',
    'Cancel the classes people have booked':
      'Скасувати заняття, на які вже записалися',
    'Change the number of spots': 'Змінити кількість місць',
    edit_schedule_capacity_hint:
      'Застосовується до занять цього розкладу, які ще не почалися, зокрема змінених окремо. Минулі заняття залишаються без змін.',
    'weekday short: sunday': 'Нд',
    'weekday short: monday': 'Пн',
    'weekday short: tuesday': 'Вт',
    'weekday short: wednesday': 'Ср',
    'weekday short: thursday': 'Чт',
    'weekday short: friday': 'Пт',
    'weekday short: saturday': 'Сб',
  },
};
